import './layoutCbam.less'

import {m} from '@codeurs/front'
import styled from '@emotion/styled'
import {Component} from 'react'
import {PageData} from 'types'
import {style} from 'util/style'
import {Tracking} from 'util/tracking'
import {Footer} from 'views/partials/footer'
import {Header} from 'views/partials/header'
import {CmsLink} from './partials/cmslink'
import {Cookiewarning} from './partials/cookiewarning'
import {H1, PrimaryButton, Theme} from './theme'

const styles = style('layoutCbam')

declare const window: Window & typeof globalThis & {env: any}

export class LayoutCbam extends Component<{
	data: PageData
}> {
	render() {
		const {language, id, cookies} = this.props.data
		return (
			<Theme
				extend={{
					H1: styled(H1)`
						line-height: 53px;
					`,
					Button: styled(PrimaryButton)`
						font-size: 17px !important;
						padding: 16px 36px !important;
					`
				}}
			>
				<div class={styles}>
					<CmsLink entry={id} lang={language} project="cbam" />
					<Header {...this.props} />
					<div class={styles('content')}>{this.props.children}</div>
					<Footer {...this.props} />
					<Tracking
						view={Cookiewarning}
						cookiesData={cookies}
						mtmCode={window.env.MTM_2050}
					/>
				</div>
			</Theme>
		)
	}
}
